var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d7ca62506600ff3bc8bb0acc97b7ef159f4b8136"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["policy-expert-site@qmetric"]={id:"d7ca62506600ff3bc8bb0acc97b7ef159f4b8136"};
      